// extracted by mini-css-extract-plugin
export var bgImgCml = "styles-module--bgImgCml--52faa";
export var bgImgDvc = "styles-module--bgImgDvc--f7791";
export var bgImgMlem = "styles-module--bgImgMlem--ace8d";
export var bgImgStudio = "styles-module--bgImgStudio--d832e";
export var company = "styles-module--company--9a739";
export var companyName = "styles-module--companyName--1767b";
export var hiddenScrollbar = "styles-module--hiddenScrollbar--6f1ad";
export var linkButton = "styles-module--linkButton--f0a47";
export var logo = "styles-module--logo--236a0";
export var logoRow = "styles-module--logoRow--de522";
export var opened = "styles-module--opened--bee77";
export var section = "styles-module--section--41bf1";
export var sectionHeading = "styles-module--sectionHeading--5fdd5";
export var sections = "styles-module--sections--e3ff5";
export var subSection = "styles-module--subSection--b8c95";
export var subSectionLink = "styles-module--subSectionLink--c76a8";
export var subSectionLinkImage = "styles-module--subSectionLinkImage--9f8a1";
export var subSectionLinkTitle = "styles-module--subSectionLinkTitle--ee340";
export var subSections = "styles-module--subSections--65400";
export var toggleButton = "styles-module--toggleButton--1c958";
export var wrapper = "styles-module--wrapper--73c06";